import React from 'react';
import { getHomePageSection } from 'hb-redux-store/feature/home/home.action';
import { connect } from 'react-redux';
import BannerCarousel from '../../web/BannerCarousel/BannerCarousel';
import { SECTIONS_PLP } from 'hb-redux-store/util/constantServices';
import PLP from './PLP';
import Loader from '../../mweb/Skeletons/Loader/Loader';
import { getSectionPLP } from '../../../hb-redux-store/feature/products/product.action';

class SectionPLP extends React.Component {
  componentDidMount() {
    this.props.getSectionPLP({ ...this.props.section, isDesktop: true });
  }
  render() {
    const { categoryPLPDetails, loading } = this.props;
    const items = categoryPLPDetails?.banners || null;
    return (
      <div className="home-page-container section-plp">
        {loading && <Loader />}
        {!loading && (
          <React.Fragment>
            {items?.length && <BannerCarousel banners={items} />}
            {categoryPLPDetails && (
              <div className="desktop-plp--heading">
                <h3 className="desktop-plp--heading--category-name bold">
                  {categoryPLPDetails.categoryName}
                </h3>
                {categoryPLPDetails.subTitle && (
                  <div className="desktop-plp--heading--sub-text">
                    {categoryPLPDetails.subTitle}
                  </div>
                )}
              </div>
            )}
            {categoryPLPDetails && (
              <PLP
                section={SECTIONS_PLP.PREORDER}
                products={categoryPLPDetails.products}
              />
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ productReducer }) => ({
  categoryPLPDetails: productReducer.categoryPLPDetails,
  loading: productReducer.loadingPdp,
});
const mapDispactchToProps = {
  getHomePageSection,
  getSectionPLP,
};

export default connect(mapStateToProps, mapDispactchToProps)(SectionPLP);
